module.exports = __webpack_public_path__ + "img/num.9193fc8f.png";